<p-tieredMenu
  #menu
  [popup]="true"
  [model]="menuItems"
  styleClass="bfx-dashboard-menu"
></p-tieredMenu>
<button
  id="single-button"
  type="button"
  class="bfx-button-secondary-subtle-unsized bfx-button-sm"
  (click)="onClickToggle($event)"
>
  <span>{{username}}</span> <i class="bfx-button-icon icon-ion_chevron_down"></i>
</button>
